import Vue from 'vue';

const mutations = {
  setFlash(state, flashMessage) {
    Vue.set(state, 'flash', flashMessage);
  },
  clearFlash(state) {
    Vue.delete(state, 'flash');
  },
};

const actions = {
  setSuccessMessage({ commit }, message) {
    commit('setFlash', {
      type: 'success',
      message,
    });
  },
  setErrorMessage({ commit }, message) {
    commit('setFlash', {
      type: 'error',
      message,
    });
  },
};

export default {
  state: {
    flash: {
      message: null,
      type: null,
    },
  },
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/notifications/index.js